import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a390d03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fields-section" }
const _hoisted_2 = { class: "templates" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = {
  key: 0,
  class: "toggles-credits"
}
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "credit-section" }
const _hoisted_8 = { class: "contact-grid" }
const _hoisted_9 = { class: "custom-cell" }
const _hoisted_10 = { class: "custom-cell" }

import { computed, ref, inject, watch } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { FieldSize } from "@/enums/system/FieldSize";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { WorkOrderEmail } from "@/types/work-orders/WorkOrderEmail";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { SMSCredits } from "@/types/sms/SMSCredits";
import { WorkOrderEmailContact } from "@/types/work-orders/WorkOrderEmailContact";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { WorkOrderTemplates } from "@/enums/work-orders/WorkOrderTemplates";
import SelectUserModal from "@/components/ui/diary/select-user-modal.vue";
import { UserDetails } from "@/types/users/UserDetails";
import { ContactSources } from "@/enums/contacts/ContactSources";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import SMSForm from "@/components/sms/sms-form.vue";
import { WorkOrders } from "acquaint-api/models/WorkOrders";
import { getFileNameParts } from "@/utils/files/CorrespondenceFileConverter";


export default /*#__PURE__*/_defineComponent({
  __name: 'email-work-order-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /**
   * The unique identifier for the work order.
   * @type {number}
   * @default 0
   */
  workOrderId: {
    type: Number,
    required: true,
  },
  /**
   * The unique identifier for the work order.
   * @type {number}
   * @default 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes.
   * This is used to update the v-model variable in the parent component and control the visibility of the modal.
   * @event update:modelValue
   * @property {boolean} value - The updated state to reflect whether the modal should be shown or hidden.
   */ "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const workOrderDetails = ref<WorkOrderEmail>({
  workOrderId: 0,
  contractorEmailTemplateId: WorkOrderTemplates.ContractorEmail,
  landlordEmailTemplateId: WorkOrderTemplates.LandlordEmail,
  tenantEmailTemplateId: WorkOrderTemplates.TenantEmail,
  contractorSmsTemplateId: WorkOrderTemplates.ContractorSMS,
  landlordSmsTemplateId: WorkOrderTemplates.LandlordSMS,
  tenantSmsTemplateId: WorkOrderTemplates.TenantSMS,
  attachImages: false,
  contacts: [],
});
const contacts = ref<WorkOrderEmailContact[]>([]);
const displayUserListModal = ref(false);
const smsCredits = ref(0);
const preview = ref(false);
const loadingData = ref(false);
const emailCredits = ref(0);
const contactsGridKey = ref(0);
const displayUserSMSModal = ref(false);
const displayTenantSMSModal = ref(false);
const displayLandlordSMSModal = ref(false);
const displayContractorSMSModal = ref(false);
const displayUserEmailModal = ref(false);
const displayTenantEmailModal = ref(false);
const displayLandlordEmailModal = ref(false);
const displayContractorEmailModal = ref(false);
const workOrder = ref<WorkOrders | undefined>();
const files = ref<File[]>([]);
const userContactIds = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.source == ContactSources.UserStaff;
    })
    .map((contact) => {
      return contact.contactId;
    });
});

// These ensure that the selected contacts are displayed in the correct SMS and email modals
const usersToText = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendSms && contact.source == ContactSources.UserStaff;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const tenantstoText = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendSms && contact.source == ContactSources.Tenant;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const landlordsToText = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendSms && contact.source == ContactSources.Landlord;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const contractorsToText = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendSms && contact.source == ContactSources.Contractor;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const usersToEmail = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendEmail && contact.source == ContactSources.UserStaff;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const tenantstoEmail = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendEmail && contact.source == ContactSources.Tenant;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const landlordsToEmail = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendEmail && contact.source == ContactSources.Landlord;
    })
    .map((contact) => {
      return contact.contactId;
    });
});
const contractorsToEmail = computed(() => {
  return contacts.value
    .filter((contact) => {
      return contact.sendEmail && contact.source == ContactSources.Contractor;
    })
    .map((contact) => {
      return contact.contactId;
    });
});

// This section handles the fetching of the relevant data
watch(
  () => showModal.value,
  async () => {
    if (!showModal.value) {
      return;
    }

    workOrder.value = await fetcWorkOrderData();
    workOrderDetails.value = {
      workOrderId: props.workOrderId,
      contractorEmailTemplateId: WorkOrderTemplates.ContractorEmail,
      landlordEmailTemplateId: WorkOrderTemplates.LandlordEmail,
      tenantEmailTemplateId: WorkOrderTemplates.TenantEmail,
      contractorSmsTemplateId: WorkOrderTemplates.ContractorSMS,
      landlordSmsTemplateId: WorkOrderTemplates.LandlordSMS,
      tenantSmsTemplateId: WorkOrderTemplates.TenantSMS,
      attachImages: workOrder.value?.pictures ? true : false,
      contacts: [],
    };
    preview.value = false;
    files.value = [];
    fetchContacts();
    fetchSmsCredits();
    fetchEmailCredits();
  },
);

const fetchContacts = async () => {
  loadingData.value = true;
  try {
    contacts.value = await apiClient.httpGet(
      `app/workorders/${props.workOrderId}/contacts`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    contacts.value = [];
  } finally {
    loadingData.value = false;
  }
};

const fetchSmsCredits = async () => {
  try {
    const rawCredits = await apiClient.httpGet<SMSCredits>(
      "app/correspondence/sms/credits",
    );
    smsCredits.value = rawCredits.total;
  } catch (err) {
    smsCredits.value = 0;
    displayErrorMessage(getErrorMessage(err));
  }
};

const fetchEmailCredits = async () => {
  try {
    emailCredits.value = await apiNextClient.httpGet(
      "/Email/getemailcreditbalance",
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    emailCredits.value = 0;
  }
};

const fetcWorkOrderData = async () => {
  try {
    return await apiClient.httpGet<WorkOrders>(
      `database/workorders/${props.workOrderId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

// This code handles users adding a user to the contact list
const onAddUserClick = () => {
  displayUserListModal.value = true;
};

const userSelected = async (userId: number) => {
  const user: UserDetails | undefined = await fetchUserDetails(userId);

  if (user) {
    contacts.value.push({
      contactId: userId,
      contact: `${user.firstNames} ${user.lastName}`,
      email: user.email,
      mobile: user.mobileTelephone,
      type: "Users / Staff",
      source: ContactSources.UserStaff,
      sendEmail: user.email ? true : false,
      sendSms: user.mobileTelephone ? true : false,
    });
  }

  contactsGridKey.value++;
};

const fetchUserDetails = async (userId: number) => {
  try {
    return await apiClient.httpGet<UserDetails>(`app/user/record/${userId}`);
  } catch (err) {
    return undefined;
  }
};

const onSendClick = async () => {
  // If the user wants to preview emails and texts, we won't queue the contacts here as the user we choose to send or cancel the messages later.
  if (!preview.value) {
    workOrderDetails.value.contacts = contacts.value.filter((contact) => {
      return contact.sendEmail || contact.sendSms;
    });
    if (!(await queueWorkOrder())) {
      return;
    }
    showModal.value = false;
    return;
  }

  let pfdFile: File;
  const pdfBlob: Blob | undefined = props.workOrderId
    ? await generatePDF()
    : undefined;
  if (pdfBlob) {
    pfdFile = new File([pdfBlob], `WorkOrder-${props.workOrderId}.pdf`, {
      type: "application/pdf",
    });
    files.value.push(pfdFile);
  }

  if (workOrder.value?.pictures && workOrderDetails.value.attachImages) {
    workOrderDetails.value.attachImages = true;
    let pictureList = workOrder.value.pictures.split("|");

    pictureList.forEach(async (image, index) => {
      const imageBlob: Blob | undefined = await fetchImage(index + 1);
      if (!imageBlob) {
        return;
      }
      const imageFile: File = new File(
        [imageBlob],
        `${getFileNameParts(image)?.name ?? image}.jpg`,
        { type: "image/jpeg" },
      );
      files.value.push(imageFile);
    });
  }

  showModal.value = false;

  if (usersToEmail.value.length > 0) {
    displayUserEmailModal.value = true;
  } else if (contractorsToEmail.value.length > 0) {
    displayContractorEmailModal.value = true;
  } else if (landlordsToEmail.value.length > 0) {
    displayLandlordEmailModal.value = true;
  } else if (tenantstoEmail.value.length > 0) {
    displayTenantEmailModal.value = true;
  } else if (usersToText.value.length > 0) {
    displayUserSMSModal.value = true;
  } else if (contractorsToText.value.length > 0) {
    displayContractorSMSModal.value = true;
  } else if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

// This code handles the sending of the email and text
const queueWorkOrder = async () => {
  try {
    await apiNextClient.httpPost(
      "WorkOrders/QueueSendingWorkOrders",
      workOrderDetails.value,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const generatePDF = async () => {
  try {
    return await apiClient.getPDF(
      `app/workorders/${props.workOrderId}/createpdf`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

const fetchImage = async (index: number) => {
  try {
    return await apiClient.getFile(
      `app/workorders/${props.workOrderId}/pictures/${index}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

// These functions ensure that the email modal is displayed for contact source - landlord, etc - as they
// have different email templates.
const emailUserModalClosed = () => {
  if (contractorsToEmail.value.length > 0) {
    displayContractorEmailModal.value = true;
  } else if (landlordsToEmail.value.length > 0) {
    displayLandlordEmailModal.value = true;
  } else if (tenantstoEmail.value.length > 0) {
    displayTenantEmailModal.value = true;
  } else if (usersToText.value.length > 0) {
    displayUserSMSModal.value = true;
  } else if (contractorsToText.value.length > 0) {
    displayContractorSMSModal.value = true;
  } else if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

const emailContractorModalClosed = () => {
  if (landlordsToEmail.value.length > 0) {
    displayLandlordEmailModal.value = true;
  } else if (tenantstoEmail.value.length > 0) {
    displayTenantEmailModal.value = true;
  } else if (usersToText.value.length > 0) {
    displayUserSMSModal.value = true;
  } else if (contractorsToText.value.length > 0) {
    displayContractorSMSModal.value = true;
  } else if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

const emailLandlordModalClosed = () => {
  if (tenantstoEmail.value.length > 0) {
    displayTenantEmailModal.value = true;
  } else if (usersToText.value.length > 0) {
    displayUserSMSModal.value = true;
  } else if (contractorsToText.value.length > 0) {
    displayContractorSMSModal.value = true;
  } else if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

const emailTenantModalClosed = () => {
  if (usersToText.value.length > 0) {
    displayUserSMSModal.value = true;
  } else if (contractorsToText.value.length > 0) {
    displayContractorSMSModal.value = true;
  } else if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

const SMSUserModalClosed = () => {
  if (contractorsToText.value.length > 0) {
    displayContractorSMSModal.value = true;
  } else if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

const SMSContractorModalClosed = () => {
  if (landlordsToText.value.length > 0) {
    displayLandlordSMSModal.value = true;
  } else if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

const SMSLandlordModalClosed = () => {
  if (tenantstoText.value.length > 0) {
    displayTenantSMSModal.value = true;
  }
};

// Cancel click
const onCancelClick = () => (showModal.value = false);

// This disables the save button when no contacts have been selected
const enableSendButton = computed(() => {
  const selectedContact = contacts.value.some((contact) => {
    return contact.sendEmail || contact.sendSms;
  });

  return selectedContact;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showModal).value = $event)),
      title: "Email Work Order",
      width: _unref(ModalWidth).Medium,
      height: "750px"
    }, {
      "non-scrollable-content": _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LookupSingleSelect, {
                label: "Contractor Email Template",
                "lookup-source": _unref(LookupTableSource).EmailTemplates,
                modelValue: workOrderDetails.value.contractorEmailTemplateId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((workOrderDetails.value.contractorEmailTemplateId) = $event)),
                width: _unref(FieldSize).Full
              }, null, 8, ["lookup-source", "modelValue", "width"]),
              _createVNode(LookupSingleSelect, {
                label: "Landlord Email Template",
                "lookup-source": _unref(LookupTableSource).EmailTemplates,
                modelValue: workOrderDetails.value.landlordEmailTemplateId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((workOrderDetails.value.landlordEmailTemplateId) = $event)),
                width: _unref(FieldSize).Full
              }, null, 8, ["lookup-source", "modelValue", "width"]),
              _createVNode(LookupSingleSelect, {
                label: "Tenant Email Template",
                "lookup-source": _unref(LookupTableSource).EmailTemplates,
                modelValue: workOrderDetails.value.tenantEmailTemplateId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((workOrderDetails.value.tenantEmailTemplateId) = $event)),
                width: _unref(FieldSize).Full
              }, null, 8, ["lookup-source", "modelValue", "width"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(LookupSingleSelect, {
                label: "Contractor SMS Template",
                "lookup-source": _unref(LookupTableSource).SMSTemplates,
                modelValue: workOrderDetails.value.contractorSmsTemplateId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((workOrderDetails.value.contractorSmsTemplateId) = $event)),
                width: _unref(FieldSize).Full
              }, null, 8, ["lookup-source", "modelValue", "width"]),
              _createVNode(LookupSingleSelect, {
                label: "Landlord SMS Template",
                "lookup-source": _unref(LookupTableSource).SMSTemplates,
                modelValue: workOrderDetails.value.landlordSmsTemplateId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((workOrderDetails.value.landlordSmsTemplateId) = $event)),
                width: _unref(FieldSize).Full
              }, null, 8, ["lookup-source", "modelValue", "width"]),
              _createVNode(LookupSingleSelect, {
                label: "Tenant SMS Template",
                "lookup-source": _unref(LookupTableSource).SMSTemplates,
                modelValue: workOrderDetails.value.tenantSmsTemplateId,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((workOrderDetails.value.tenantSmsTemplateId) = $event)),
                width: _unref(FieldSize).Full
              }, null, 8, ["lookup-source", "modelValue", "width"])
            ])
          ]),
          (workOrderDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(SwitchToggle, {
                    readOnly: false,
                    label: "Attach Images",
                    "label-width": "9.5rem",
                    modelValue: workOrderDetails.value.attachImages,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((workOrderDetails.value.attachImages) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(SwitchToggle, {
                    readOnly: false,
                    label: "Preview Before Sending",
                    "label-width": "9.5rem",
                    modelValue: preview.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((preview).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(AcquaintInfoBox, {
                    label: "SMS Credits Remaining",
                    text: smsCredits.value.toString(),
                    width: _unref(FieldSize).XSmall
                  }, null, 8, ["text", "width"]),
                  _createVNode(AcquaintInfoBox, {
                    label: "Email Credits Remaining",
                    text: emailCredits.value.toString(),
                    width: _unref(FieldSize).XSmall
                  }, null, 8, ["text", "width"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createBlock(GridBase, {
            key: contactsGridKey.value,
            dataSource: contacts.value,
            "id-column-name": "contactId",
            wordWrapEnabled: true,
            customColumnSlots: ['sendSmsTemplate', 'sendEmailTemplate'],
            loading: loadingData.value,
            showSearchPanel: false
          }, {
            columns: _withCtx(() => [
              _createVNode(_unref(DxColumn), {
                "data-field": "contact",
                caption: "Contact",
                "hiding-priority": 6
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "email",
                caption: "Email",
                "hiding-priority": 5,
                width: "125px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "mobile",
                caption: "Mobile",
                "hiding-priority": 4,
                width: "100px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "type",
                caption: "Type",
                "hiding-priority": 3,
                width: "100px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "sendEmail",
                caption: "Send Email",
                "hiding-priority": 2,
                "cell-template": "sendEmailTemplate",
                width: "100px"
              }),
              _createVNode(_unref(DxColumn), {
                "data-field": "sendSms",
                caption: "Send SMS",
                "hiding-priority": 1,
                "cell-template": "sendSmsTemplate",
                width: "100px"
              })
            ]),
            sendEmailTemplateData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(SwitchToggle, {
                  modelValue: data.sendEmail,
                  "onUpdate:modelValue": ($event: any) => ((data.sendEmail) = $event),
                  "read-only": !data.email
                }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only"])
              ])
            ]),
            sendSmsTemplateData: _withCtx(({ data }) => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(SwitchToggle, {
                  modelValue: data.sendSms,
                  "onUpdate:modelValue": ($event: any) => ((data.sendSms) = $event),
                  "read-only": !data.mobile
                }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only"])
              ])
            ]),
            _: 1
          }, 8, ["dataSource", "loading"]))
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Add User',
          onClick: () => {
            onAddUserClick();
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          disabled: !enableSendButton.value,
          text: 'Send',
          onClick: () => {
            onSendClick();
          },
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"]),
    _createVNode(SelectUserModal, {
      modelValue: displayUserListModal.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((displayUserListModal).value = $event)),
      onSelectUser: userSelected,
      idsToHide: userContactIds.value
    }, null, 8, ["modelValue", "idsToHide"]),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(SMSForm, {
          key: 0,
          modelValue: displayUserSMSModal.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((displayUserSMSModal).value = $event)),
          contactList: usersToText.value,
          "sms-template": workOrderDetails.value.contractorSmsTemplateId,
          onEmailSent: SMSUserModalClosed,
          onCancelPromptAccepted: SMSUserModalClosed,
          workOrderId: props.workOrderId,
          "property-id": props.propertyId
        }, null, 8, ["modelValue", "contactList", "sms-template", "workOrderId", "property-id"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(SMSForm, {
          key: 1,
          modelValue: displayContractorSMSModal.value,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((displayContractorSMSModal).value = $event)),
          contactList: contractorsToText.value,
          "sms-template": workOrderDetails.value.contractorSmsTemplateId,
          onEmailSent: SMSContractorModalClosed,
          onCancelPromptAccepted: SMSContractorModalClosed,
          workOrderId: props.workOrderId,
          "property-id": props.propertyId
        }, null, 8, ["modelValue", "contactList", "sms-template", "workOrderId", "property-id"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(SMSForm, {
          key: 2,
          modelValue: displayLandlordSMSModal.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((displayLandlordSMSModal).value = $event)),
          contactList: landlordsToText.value,
          "sms-template": workOrderDetails.value.landlordSmsTemplateId,
          onEmailSent: SMSLandlordModalClosed,
          onCancelPromptAccepted: SMSLandlordModalClosed,
          workOrderId: props.workOrderId,
          "property-id": props.propertyId
        }, null, 8, ["modelValue", "contactList", "sms-template", "workOrderId", "property-id"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(SMSForm, {
          key: 3,
          modelValue: displayTenantSMSModal.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((displayTenantSMSModal).value = $event)),
          contactList: tenantstoText.value,
          "sms-template": workOrderDetails.value.tenantSmsTemplateId,
          workOrderId: props.workOrderId,
          "property-id": props.propertyId
        }, null, 8, ["modelValue", "contactList", "sms-template", "workOrderId", "property-id"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(EmailFormModal, {
          key: 4,
          defaultFiles: files.value,
          modelValue: displayUserEmailModal.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((displayUserEmailModal).value = $event)),
          "contact-list": usersToEmail.value,
          workOrderId: props.workOrderId,
          onEmailSent: emailUserModalClosed,
          onCancelPromptAccepted: emailUserModalClosed,
          "email-template-id": workOrderDetails.value.contractorEmailTemplateId,
          propertyRelatedToId: props.propertyId
        }, null, 8, ["defaultFiles", "modelValue", "contact-list", "workOrderId", "email-template-id", "propertyRelatedToId"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(EmailFormModal, {
          key: 5,
          defaultFiles: files.value,
          modelValue: displayContractorEmailModal.value,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((displayContractorEmailModal).value = $event)),
          "contact-list": contractorsToEmail.value,
          "email-template-id": workOrderDetails.value.contractorEmailTemplateId,
          onEmailSent: emailContractorModalClosed,
          onCancelPromptAccepted: emailContractorModalClosed,
          workOrderId: props.workOrderId,
          propertyRelatedToId: props.propertyId
        }, null, 8, ["defaultFiles", "modelValue", "contact-list", "email-template-id", "workOrderId", "propertyRelatedToId"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(EmailFormModal, {
          key: 6,
          defaultFiles: files.value,
          modelValue: displayLandlordEmailModal.value,
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((displayLandlordEmailModal).value = $event)),
          "contact-list": landlordsToEmail.value,
          "email-template-id": workOrderDetails.value.landlordEmailTemplateId,
          onEmailSent: emailLandlordModalClosed,
          onCancelPromptAccepted: emailLandlordModalClosed,
          workOrderId: props.workOrderId,
          propertyRelatedToId: props.propertyId
        }, null, 8, ["defaultFiles", "modelValue", "contact-list", "email-template-id", "workOrderId", "propertyRelatedToId"]))
      : _createCommentVNode("", true),
    (workOrderDetails.value)
      ? (_openBlock(), _createBlock(EmailFormModal, {
          key: 7,
          defaultFiles: files.value,
          modelValue: displayTenantEmailModal.value,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((displayTenantEmailModal).value = $event)),
          "contact-list": tenantstoEmail.value,
          workOrderId: props.workOrderId,
          onEmailSent: emailTenantModalClosed,
          onCancelPromptAccepted: emailTenantModalClosed,
          "email-template-id": workOrderDetails.value.tenantEmailTemplateId,
          propertyRelatedToId: props.propertyId
        }, null, 8, ["defaultFiles", "modelValue", "contact-list", "workOrderId", "email-template-id", "propertyRelatedToId"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})